import React from 'react';
import GroupChannelList from '@sendbird/uikit-react/GroupChannelList';
import { useConnectionState } from '@sendbird/uikit-react/hooks/useConnectionState';
import { ConnectionState } from '@sendbird/chat';
import { useSendbird } from '@sendbird/uikit-react';
import type { GroupChannel } from '@sendbird/chat/groupChannel';
import { ActivityIndicator } from 'react-native';
import { green } from '@/shared/styles/colors';
import styled from '@emotion/native';
import { BaseText } from '@/shared/components/StyledText';

export interface ChannelListViewProps {
  selectedChannelUrl?: string;
  disableAutoSelect?: boolean;
  onChannelSelect: (channel: GroupChannel) => void;
  onChannelCreated: (channel: GroupChannel) => void;
}

export default function ChannelListView({
  selectedChannelUrl,
  disableAutoSelect = false,
  onChannelSelect,
  onChannelCreated,
}: ChannelListViewProps) {
  const connectionState = useConnectionState();
  const {
    state: {
      stores: {
        sdkStore: { sdk },
      },
    },
  } = useSendbird();

  // Only render GroupChannelList when Sendbird is connected and SDK is ready
  // This prevents the component from querying channels before authentication is complete,
  // which can cause "no channels" to appear even when channels exist
  const isReady = connectionState === ConnectionState.OPEN && sdk?.groupChannel;

  if (!isReady) {
    return (
      <LoadingContainer>
        <BaseText>Loading Channels</BaseText>
        <ActivityIndicator
          size="large"
          color={green}
          style={{ marginVertical: 16 }}
        />
        <BaseText style={{ textAlign: 'center' }}>
          If a chat shows up and you still see this message, please refresh the
          page.
        </BaseText>
      </LoadingContainer>
    );
  }

  return (
    <GroupChannelList
      disableAutoSelect={disableAutoSelect}
      renderHeader={() => <></>}
      channelListQueryParams={{ includeEmpty: true }}
      selectedChannelUrl={selectedChannelUrl}
      allowProfileEdit={false}
      onChannelSelect={onChannelSelect}
      onChannelCreated={onChannelCreated}
    />
  );
}

const LoadingContainer = styled.View(() => ({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  paddingHorizontal: 12,
}));
